/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UploadPaymentRequestEvidenceImageRequest
 */
export interface UploadPaymentRequestEvidenceImageRequest {
    /**
     * 
     * @type {File}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'file'?: File;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'electronicMethod'?: UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'documentSize'?: UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPaymentRequestEvidenceImageRequest
     */
    'asQualified'?: boolean | null;
}

export const UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum = typeof UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum[keyof typeof UploadPaymentRequestEvidenceImageRequestElectronicMethodEnum];
export const UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum = typeof UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum[keyof typeof UploadPaymentRequestEvidenceImageRequestDocumentSizeEnum];


